// @flow
export const filterId: 'commonBalance' = 'commonBalance';
